import React, { useState } from 'react'
import {
  getGuestCartContents,
  removeGuestCartItem,
  addGuestCartItem,
  updateGuestCartItemQuantity,
  GuestOrder
} from '#src/services/cart'

export interface GuestCartContext {
  data?: {
    order: GuestOrder
    syncOrder: () => GuestOrder
    removeGuestCartItem: (sellableId: string) => void
    updateGuestCartItemQuantity: (sellableId: string, quantity: number) => void
    addGuestCartItem: (sellableId: string) => void
  }
}

interface GuestCartObserverProps {
  children: ({ data }: GuestCartContext) => void
  loading: boolean
}

const GuestCartObserver: React.SFC<GuestCartObserverProps> = ({ children, loading }) => {
  const [guestCartContents, setGuestCartContents] = useState(getGuestCartContents())
  const syncOrder = () => {
    setGuestCartContents(getGuestCartContents())

    return guestCartContents
  }

  if (loading) {
    return <>{children({})}</>
  } else {
    return (
      <>
        {children({
          data: {
            order: guestCartContents,
            addGuestCartItem: sellableId => {
              addGuestCartItem(sellableId)
              syncOrder()
            },
            removeGuestCartItem: sellableId => {
              removeGuestCartItem(sellableId)
              syncOrder()
            },
            updateGuestCartItemQuantity: (sellableId, quantity) => {
              updateGuestCartItemQuantity(sellableId, quantity)
              syncOrder()
            },
            syncOrder
          }
        })}
      </>
    )
  }
}

export default GuestCartObserver
